import { useQuery } from 'react-query';

import { useServiceError } from '@/hooks';

import { listStates } from './States.service';
import { queryClient } from '@/Root';

export function useStates(enabled = true) {
  const cache = queryClient.getQueryData(['states']);

  const query = useQuery(['states'], () => listStates(), {
    enabled: enabled && !cache,
  });

  useServiceError(query.error);

  return query;
}
